document.addEventListener("DOMContentLoaded", function () {
  let isLoading = false; // Prevent multiple calls

  function loadMoreProducts() {
    let loadingSpinner = document.querySelector(".load-more-container");
    let allProductsContainer = document.querySelector(
      ".products-loading-container"
    );

    let nextPageLink = document.querySelector(".next-page-link");
    if (nextPageLink) {
      isLoading = true;
      let nextPageUrl = nextPageLink.getAttribute("href");
      // console.log("nextPageUrl is:", nextPageUrl);
      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((data) => {
          // Parse the response HTML
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, "text/html");
          // console.log("doc is:", doc.querySelector(".product-grid-container .collection"));
          let newProducts = doc.querySelectorAll(".li-grid__item");
          console.log("newProducts are:", newProducts);
          console.log("allProductsContainer is:", allProductsContainer);
          // Append new products to the existing product grid
          newProducts.forEach((product) => {
            allProductsContainer.appendChild(product);
          });
          // Update the next link to the next page
          let newNextPageLink = doc.querySelector(".next-page-link");
          // console.log("nextPageLink is:", nextPageLink);
          if (newNextPageLink) {
            nextPageLink.setAttribute(
              "href",
              `${newNextPageLink.getAttribute("href")}`
            );
          } else {
            // If there's no next page, remove the next link tag
            nextPageLink.remove();
          }

          // console.log("after else newNextPageLink is:", newNextPageLink);
          // Allow further scroll loading
          isLoading = false;
        })
        .catch((error) => console.error("Error loading more products:", error))
        .finally(() => {
          // Hide spinner after the request is complete
          loadingSpinner.style.display = "none";
        });
    } else {
      loadingSpinner.style.display = "none";
    }
  }

  window.onscroll = function () {
    let loadingSpinner = document.querySelector(".load-more-container");
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 700) {
      if (!isLoading) {
        loadingSpinner.style.display = "flex";
        loadMoreProducts();
      }
    }
  };
});
